import { BaseResponseAttributes } from "../attributes/base-attributes";
import { RestApiResponse } from "./RestApi";
import BaseService from "./BaseService";
import { BusinessWithdrawPercentAttributes, BusinessWithdrawPercentSearchAttributes } from "../attributes/business-withdraw-percent-attributes";
import BusinessWithdrawPercent from "../models/BusinessWithdrawPercent";
export class BusinessWithdrawPercentService extends BaseService {
  static async getAll(): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessWithdrawPercentService.getApiClient().get(
      `admin/business-withdraw-percents`
    );
  }

  static async deleteBusinessPercent(withdrawPercentId: number): Promise<RestApiResponse<BaseResponseAttributes>> {
    return BusinessWithdrawPercentService.getApiClient().delete(
      `admin/business-withdraw-percents/${withdrawPercentId}/delete`
    );
  }

  static async addWithdrawPercent(
    data: BusinessWithdrawPercentAttributes
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    const url: string = "admin/business-withdraw-percents/add";

    const formData = new FormData();

    // Add text data
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    return BusinessWithdrawPercentService.getApiClient().sendFormData({
      method: "post",
      url: url,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static async updateWithdrawPercent(
    withdrawPercentId: number,
    data: BusinessWithdrawPercent
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    const url: string = `admin/business-withdraw-percents/${withdrawPercentId}/update`;

    const formData = new FormData();

    // Add text data
    Object.keys(data).forEach((key) => {
      if (key === "business") {
        formData.append("business_id", data[key].id.toString());
      } else {
        formData.append(key, data[key]);
      }
    });

    return BusinessWithdrawPercentService.getApiClient().sendFormData({
      method: "post",
      url: url,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static async searchPercents(
      data: BusinessWithdrawPercentSearchAttributes,
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    const url: string = `admin/business-withdraw-percents/search`;

    const formData = new FormData();

    // Add text data
    Object.keys(data).forEach((key) => {
      if(key === 'business' && data[key]!==null){
        formData.append('business_id', data[key].id.toString());
      }else {
        formData.append(key, data[key]);
      }
    });

    return BusinessWithdrawPercentService.getApiClient().sendFormData({
      method: "post",
      url: url,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

}

export default BusinessWithdrawPercentService;
